import LangEnum from '../../../lang/LangEnum';
import {
  CatalogCreationAccessAddConfig,
  CatalogCreationAccessFieldName,
  CatalogCreationAccessTabConfig,
} from './catalogCreationAccess.types';
import { CatalogCreationAccessAddFormValues } from './catalogCreationAccessAdd.schema';

export const CATALOG_CREATION_ACCESS_TABS: CatalogCreationAccessTabConfig[] = [
  {
    field: 'classificationPermissions',
    label: LangEnum.GLOBAL_CUSTOMERS_CLASSIFICATIONS,
  },
  { field: 'customers', label: LangEnum.GLOBAL_CUSTOMERS },
  { field: 'salesRepresentatives', label: LangEnum.GLOBAL_SALES_REPRESENTATIVES },
];

export const CATALOG_CREATION_ACCESS_ADD_CONFIG_BY_FIELD: Record<
  CatalogCreationAccessFieldName,
  CatalogCreationAccessAddConfig
> = {
  classificationPermissions: {
    title: LangEnum.CATALOGS_BULK_ADD_CLASSIFICATIONS_MODAL_TITLE,
    entityLabel: LangEnum.GLOBAL_CUSTOMERS_CLASSIFICATIONS,
    labelField: 'name',
    source: {
      url: 'filter-options/catalog-access-classifications',
      queryField: 'query',
      order: { name: 'ASC' },
    },
  },
  customers: {
    title: LangEnum.CATALOGS_BULK_ADD_CUSTOMERS_MODAL_TITLE,
    entityLabel: LangEnum.GLOBAL_CUSTOMERS,
    labelField: 'commercialName',
    source: {
      url: 'customers',
      queryField: 'query',
      idsAlias: 'customersIds',
      order: { commercialName: 'ASC' },
    },
  },
  salesRepresentatives: {
    title: LangEnum.CATALOGS_BULK_ADD_SALES_REPS_MODAL_TITLE,
    entityLabel: LangEnum.GLOBAL_SALES_REPRESENTATIVES,
    labelField: 'name',
    source: {
      url: 'sales-representatives',
      queryField: 'nameOrCode',
      order: { name: 'ASC' },
      defaultQuery: { active: true },
    },
  },
};

export const CATALOG_ACCESS_AVAILABLE_PATH_BY_FIELD: Record<
  CatalogCreationAccessFieldName,
  string
> = {
  classificationPermissions: 'classification-permissions/available',
  customers: 'customers/available',
  salesRepresentatives: 'sales-representatives/available',
};

export const CATALOG_CREATION_ACCESS_ADD_DEFAULT_VALUES: CatalogCreationAccessAddFormValues = {
  entityIds: [],
  startDate: null,
  endDate: null,
};

export const CATALOG_CREATION_ACCESS_CATALOG_DATE_FORMAT = 'P p';

export const CATALOG_CREATION_ACCESS_ENTITY_COLUMN_WIDTH = 260;
export const CATALOG_CREATION_ACCESS_DATE_COLUMN_WIDTH = 210;

export const CATALOG_CREATION_ACCESS_TABLE_HEADER_HEIGHT = 40;
export const CATALOG_CREATION_ACCESS_TABLE_ROW_HEIGHT = 44;
export const CATALOG_CREATION_ACCESS_TABLE_MAX_VISIBLE_ROWS = 5;
